/**
 * Texte in DE und EN (NFR-I18N-01).
 *
 * Ein flaches Objekt und keine Bibliothek: die Menge ist ueberschaubar,
 * und ein fehlender Schluessel soll beim Bauen auffallen und nicht im
 * Betrieb als roher Schluessel auf dem Bildschirm stehen.
 *
 * Die Rueckfragen gibt es zweimal, in Mundart und auf Hochdeutsch. Welche
 * gilt, entscheidet der Admin pro Event (FR-CONF-05).
 */
export type Lang = 'de' | 'en'
export type Tone = 'mundart' | 'hochdeutsch'

const de = {
  'app.name': 'Bullshit Bingo',
  'app.tagline': 'Markieren. Bestätigen lassen. Bingo.',
  'head.admin': 'Verwaltung',
  'head.board': 'Rangliste',
  'head.account': 'Konto',
  'head.console': 'Konsole',
  'head.thanks': 'Danke',
  'head.rules': 'Regeln',
  'head.room': 'Raum',
  'head.imprint': 'Impressum',
  'head.privacy': 'Datenschutz',


  'start.public': 'Öffentliche Räume',
  'start.players': '{n} dabei',
  'start.upcoming': 'Gleich',
  'start.solo': 'Einfach ausprobieren',
  'start.soloHint': 'Allein, ohne Raum. Zählt für nichts.',
  'podcast.kicker': 'ZweiOnCTI, der Podcast dazu',
  'podcast.episode': 'Folge {n}',
  'podcast.listen': 'Folge anhören',
  'podcast.allEpisodes': 'Alle Folgen',
  'podcast.noEpisode': 'Die Show läuft auf Spotify und Apple Podcasts.',
  'start.join': 'Mit Code beitreten',
  'start.joinHint': 'Mit dem Code vom Aufsteller, zum Beispiel BSB-XK7T',
  'start.create': 'Eigenen Raum erstellen',
  'start.createHint': 'Für einen Vendor-Pitch, ein Webinar oder eine Sitzung. Braucht ein Konto.',
  'start.noEvent': 'Gerade läuft kein Event. Mit einem Code kommst du trotzdem rein.',
  'start.noRooms': 'Noch keine offenen Räume.',
  'start.rules': 'Regeln',
  'start.myStuff': 'Mein Konto und Verlauf',
  'start.signIn': 'Konto anlegen oder anmelden',
  'start.accountWhy': 'Mit einem Konto kannst du eigene Räume anlegen und findest deinen Verlauf und deine Zertifikate wieder. Spielen geht auch ohne.',
  'start.accountHave': 'Deine Räume, dein Verlauf und deine Zertifikate.',

  'room.players': 'im Raum',
  'room.marks2min': 'Markierungen, 2 Min',
  'room.waiting': 'Der Raum ist noch nicht gestartet.',
  'room.paused': 'Pause.',
  'room.ended': 'Vorbei. Die Wertung steht.',
  'room.board': 'Rangliste',
  'room.oneAway': 'Ein Feld fehlt',
  'room.provisional': 'Unter Vorbehalt',
  'room.bingo': 'Bingo',
  'room.report': 'Bingo melden',
  'room.reshuffle': 'Neu mischen',
  'room.newCard': 'Neue Karte',
  'room.practiceBingo': 'In der Übungsrunde bestätigt niemand. Darum gibt es dafür kein Zertifikat: ein Beleg ohne zweite Quelle wäre genau die Behauptung, die dieses Spiel vorführt. Für ein echtes Bingo brauchst du einen Raum mit anderen.',
  'room.unmark': 'Markierung aufheben',
  'room.autoInfo': 'Nach dem Markieren erklären',
  'room.leave': 'Raum verlassen',
  'room.gm': 'Spielleiter',
  'room.checking': 'Wird geprüft',

  'legend.title': 'Bewertung',
  'legend.a1': 'Spielleiter bestätigt',
  'legend.b2': 'mehrfach bestätigt',
  'legend.c3': 'einfach bestätigt',
  'legend.pend': 'läuft noch',
  'legend.f6': 'keine zweite Quelle',
  'legend.e5': 'verworfen',

  'term.plain': 'Im Klartext',
  'term.variants': 'Klingt auch so',
  'term.why': 'Warum das nicht trägt',
  'term.question': 'Frag den Vendor',
  'term.recommend': 'Was stattdessen zählt',
  'term.evidence': 'Belege',
  'term.noEvidence': 'Zu dieser Floskel haben wir keinen Beleg hinterlegt. Dann steht hier auch keiner.',
  'term.grade': 'Unsere Bewertung',
  'term.heardToday': 'Heute {n}-mal gehört',
  'term.close': 'Schliessen',

  'ask.title': 'Bisch sicher?',
  'ask.keep': 'Ich hab’s gehört',
  'ask.drop': 'Verdrückt, weg damit',

  'form.title': 'Bingo melden',
  'form.lead': 'Damit wir dir das Zertifikat schicken und uns melden dürfen.',
  'form.firstName': 'Vorname',
  'form.lastName': 'Nachname',
  'form.company': 'Firma',
  'form.email': 'Geschäftliche E-Mail',
  'form.role': 'Funktion',
  'form.interests': 'Interessiert an',
  'form.phrase': 'Floskel des Tages',
  'form.phraseHint': 'Etwas gehört, das uns fehlt?',
  'form.consent': 'Ich bin einverstanden, dass CICS mich zu diesem Thema kontaktiert. Widerruf jederzeit.',
  'form.claimCheck': 'Vendor-Claim-Check: 30 Minuten, in denen wir die Behauptungen aus einem Pitch durchgehen.',
  'form.claimCheckFirst': 'Du hast das erste Bingo des Tages.',
  'form.submit': 'Absenden',
  'form.sending': 'Wird gesendet',
  'form.freemail': 'Das sieht nach einer privaten Adresse aus. Geht auch.',
  'form.done': 'Bestätigungsmail ist unterwegs.',
  'form.certReady': 'Dein Zertifikat ist fertig.',
  'form.certShow': 'Zertifikat ansehen',

  'gm.title': 'Spielleiter',
  'gm.search': 'Floskel suchen',
  'gm.confirm': 'Bestätigen',
  'gm.veto': 'Verwerfen',
  'gm.undo': 'Rückgängig',
  'gm.undoWindow': '30 Sekunden',
  'gm.feed': 'Gerade markiert',
  'gm.queue': 'Bingos prüfen',
  'gm.approve': 'Freigeben',
  'gm.reject': 'Ablehnen',
  'gm.reason': 'Begründung',
  'gm.start': 'Starten',
  'gm.pause': 'Pause',
  'gm.end': 'Beenden',
  'gm.announce': 'Durchsage',
  'gm.nobody': 'Noch nichts markiert.',
  'gm.players': '{n} markieren',

  'board.rank': 'Platz',
  'board.points': 'Punkte',
  'board.quality': 'Quellenlage',
  'board.you': 'Du',
  'board.empty': 'Noch keine Punkte.',
  'board.topToday': 'Heute am häufigsten',
  'board.lastBingos': 'Letzte Bingos',
  'board.joinNow': 'Mitspielen',

  'create.title': 'Raum erstellen',
  'create.occasion': 'Anlass',
  'create.visibility': 'Wer kommt rein',
  'create.namePlaceholder': 'Vendor-Pitch Dienstag',
  'create.private': 'Nur mit Code',
  'create.privateHint': 'Der Raum steht nirgends. Du gibst den Code weiter.',
  'create.public': 'Öffentlich',
  'create.publicHint': 'Der Raum steht auf der Startseite. Der Code funktioniert weiterhin.',
  'create.occasion.vendor_pitch': 'Vendor-Pitch',
  'create.occasion.webinar': 'Webinar',
  'create.occasion.conference': 'Konferenz',
  'create.occasion.internal_meeting': 'Internes Meeting',
  'create.set': 'Kartenset',
  'create.name': 'Titel',
  'create.rules': 'Regeln',
  'create.gmMode': 'Wer bestätigt',
  'create.gmMode.crowd': 'Die anderen im Raum',
  'create.gmMode.hybrid': 'Raum oder Spielleiter',
  'create.gmMode.strict': 'Nur der Spielleiter',
  'create.minSources': 'Ein Feld zählt ab',
  'create.minSources.1': 'einer Quelle',
  'create.minSources.2': 'zwei Quellen',
  'create.submit': 'Raum erstellen',
  'create.done': 'Raum steht',
  'create.invite': 'Einladen',
  'create.calendar': 'In den Kalender',
  'create.copy': 'Link kopieren',
  'create.copied': 'Kopiert',

  'admin.title': 'Verwaltung',
  'admin.events': 'Events',
  'admin.newEvent': 'Event anlegen',
  'admin.rooms': 'Öffentliche Räume',
  'admin.newRoom': 'Raum anlegen',
  'admin.roomTitle': 'Titel des Vortrags',
  'admin.start': 'Starten',
  'admin.pause': 'Pause',
  'admin.end': 'Beenden',
  'admin.open': 'Öffnen',
  'admin.leads': 'Leads',
  'admin.export': 'Als CSV',
  'admin.standee': 'Aufsteller',
  'admin.noAccess': 'Dafür braucht es ein Konto mit Admin-Rechten.',
  'admin.live': 'Dieses Event ist live',
  'admin.goLive': 'Live schalten',
  'admin.players': 'Spieler',
  'admin.marks': 'Markierungen',
  'account.title': 'Konto',
  'account.email': 'E-Mail',
  'account.send': 'Link schicken',
  'account.magicHow': 'Adresse eintragen, Link in der Mail öffnen, fertig. Gibt es noch kein Konto, entsteht es dabei.',
  'account.noPassword': 'Kein Passwort. Der Link gilt 15 Minuten und genau einmal.',
  'account.sent': 'Link ist unterwegs. Er gilt 15 Minuten.',
  'account.name': 'Name in der Rangliste',
  'account.nameHint': 'Nur das sehen die anderen im Raum. Dein Konto läuft über die E-Mail-Adresse.',
  'account.signedInAs': 'Angemeldet als',
  'account.save': 'Speichern',
  'account.profile': 'Dein Profil',
  'account.profileHint': 'Je mehr wir wissen, desto besser der Report und das Gespraech danach. Alles freiwillig.',
  'account.realName': 'Name',
  'account.company': 'Firma',
  'account.role': 'Rolle',
  'account.sector': 'Branche',
  'account.country': 'Land',
  'account.petPeeve': 'Deine Lieblingsfloskel (zum Fremdschaemen)',
  'account.petPeevePh': 'z.B. „KI-gestützt, Single Pane of Glass"',
  'account.newsletter': 'Haltet mich auf dem Laufenden, bsbingo und CICS, falls es je einen Newsletter gibt. Kein Spam, Ehrenwort.',
  'account.saved': 'Gespeichert',
  'account.nameTaken': 'Der Name ging nicht durch. Wir haben einen anderen gesetzt.',
  'account.history': 'Verlauf',
  'account.certificates': 'Zertifikate',
  'account.rooms': 'Meine Räume',
  'account.joinedRooms': 'Mitgespielt',
  'start.unknownCode': 'Diesen Code kennen wir nicht. Tippfehler? Oder der Raum ist schon zu.',
  'account.export': 'Daten exportieren',
  'account.delete': 'Konto löschen',
  'account.deleteSure': 'Wirklich löschen? Das lässt sich nicht rückgängig machen.',

  'live.polling': 'Verbindung schwach. Es läuft weiter.',
  'live.offline': 'Kein Netz. Deine Markierungen werden nachgereicht.',
  'live.queued': '{n} wartet auf Netz',
  'live.synced': 'Nachgereicht.',

  'intro.title': 'So geht es',
  'intro.step1': 'Tippe an, was du gerade gehört hast.',
  'intro.step2': 'Haben es andere auch gehört, zählt das Feld.',
  'intro.step3': 'Fünf in einer Reihe sind ein Bingo.',
  'card.modeInfo': 'Klartext zeigen',
  'card.modeMark': 'Weiter markieren',
  'card.markHint': 'Tippen markiert. Lang drücken zeigt den Klartext.',
  'card.tapHint': 'Ein Tipp markiert und erklärt. Nochmal tippen zeigt es wieder.',
  'card.infoHint': 'Tippen zeigt Klartext, Bewertung und die Frage an den Vendor.',
  'why.title': 'Warum zählt noch nichts?',
  'why.needSource': 'Ein Feld zählt erst, wenn jemand anders im Raum dieselbe Floskel markiert. {n} deiner Felder warten darauf.',
  'why.smallRoom': 'Ihr seid zu wenige für die Bestätigungspflicht. Sobald mehr im Raum sind, zählt ein Feld erst mit einer zweiten Quelle.',
  'intro.step4': 'Halte ein Feld gedrückt, dann steht da, was die Floskel wirklich heisst.',
  'intro.start': 'Los',
  'intro.skip': 'Überspringen',

  'err.offline': 'Keine Verbindung.',
  'err.room_code_unknown': 'Zu diesem Code gibt es keinen offenen Raum.',
  'err.not_running': 'Der Raum läuft gerade nicht.',
  'err.card_locked': 'Die Karte ist gesperrt, seit der Raum läuft.',
  'err.reroll_used': 'Einmal neu mischen, mehr nicht.',
  'err.banned': 'Du wurdest aus diesem Raum entfernt.',
  'err.consent_missing': 'Ohne Einwilligung geht es nicht.',
  'err.lead_exists': 'Diese Adresse ist für dieses Event schon eingetragen.',
  'err.rate_limited': 'Etwas langsamer.',
  'err.generic': 'Das hat nicht geklappt.',

  'common.back': 'Zurück',
  'common.cancel': 'Abbrechen',
  'common.close': 'Schliessen',
  'common.loading': 'Einen Moment',
  'common.retry': 'Nochmal',
  'common.language': 'Sprache',
  'common.theme': 'Darstellung',
}

type Key = keyof typeof de

const en: Record<Key, string> = {
  'app.name': 'Bullshit Bingo',
  'app.tagline': 'Mark it. Get it confirmed. Bingo.',
  'head.admin': 'Administration',
  'head.board': 'Leaderboard',
  'head.account': 'Account',
  'head.console': 'Console',
  'head.thanks': 'Thank you',
  'head.rules': 'Rules',
  'head.room': 'Room',
  'head.imprint': 'Imprint',
  'head.privacy': 'Privacy',


  'start.public': 'Public rooms',
  'start.players': '{n} playing',
  'start.upcoming': 'Up next',
  'start.solo': 'Just try it out',
  'start.soloHint': 'On your own, no room. Counts for nothing.',
  'podcast.kicker': 'ZweiOnCTI, the podcast behind it',
  'podcast.episode': 'Episode {n}',
  'podcast.listen': 'Listen to the episode',
  'podcast.allEpisodes': 'All episodes',
  'podcast.noEpisode': 'The show runs on Spotify and Apple Podcasts.',
  'start.join': 'Join with a code',
  'start.joinHint': 'With the code from the standee, for example BSB-XK7T',
  'start.create': 'Create your own room',
  'start.createHint': 'For a vendor pitch, a webinar or a meeting. Needs an account.',
  'start.noEvent': 'No event running. A code still gets you in.',
  'start.noRooms': 'No open rooms yet.',
  'start.rules': 'Rules',
  'start.myStuff': 'My account and history',
  'start.signIn': 'Create an account or sign in',
  'start.accountWhy': 'With an account you can create your own rooms and find your history and certificates again. Playing works without one.',
  'start.accountHave': 'Your rooms, your history and your certificates.',

  'room.players': 'in the room',
  'room.marks2min': 'marks, 2 min',
  'room.waiting': 'The room has not started yet.',
  'room.paused': 'Paused.',
  'room.ended': 'Over. The score stands.',
  'room.board': 'Leaderboard',
  'room.oneAway': 'One field to go',
  'room.provisional': 'Provisional',
  'room.bingo': 'Bingo',
  'room.report': 'Report bingo',
  'room.reshuffle': 'Reshuffle',
  'room.newCard': 'New card',
  'room.practiceBingo': 'In a practice round nobody confirms. That is why there is no certificate: evidence without a second source would be exactly the claim this game exposes. For a real bingo you need a room with other people.',
  'room.unmark': 'Remove the mark',
  'room.autoInfo': 'Explain after marking',
  'room.leave': 'Leave room',
  'room.gm': 'Game master',
  'room.checking': 'Under review',

  'legend.title': 'Rating',
  'legend.a1': 'confirmed by the game master',
  'legend.b2': 'confirmed several times',
  'legend.c3': 'confirmed once',
  'legend.pend': 'still open',
  'legend.f6': 'no second source',
  'legend.e5': 'rejected',

  'term.plain': 'In plain words',
  'term.variants': 'Also sounds like',
  'term.why': 'Why it does not hold',
  'term.question': 'Ask the vendor',
  'term.recommend': 'What to require instead',
  'term.evidence': 'Evidence',
  'term.noEvidence': 'We have no source on file for this phrase. So none is shown.',
  'term.grade': 'Our rating',
  'term.heardToday': 'Heard {n} times today',
  'term.close': 'Close',

  'ask.title': 'Sure about that?',
  'ask.keep': 'I heard it',
  'ask.drop': 'Mis-tapped, drop it',

  'form.title': 'Report your bingo',
  'form.lead': 'So we can send the certificate and get in touch.',
  'form.firstName': 'First name',
  'form.lastName': 'Last name',
  'form.company': 'Company',
  'form.email': 'Work email',
  'form.role': 'Role',
  'form.interests': 'Interested in',
  'form.phrase': 'Phrase of the day',
  'form.phraseHint': 'Heard one we are missing?',
  'form.consent': 'I agree that CICS may contact me about this. Revocable at any time.',
  'form.claimCheck': 'Vendor Claim Check: 30 minutes going through the claims from a pitch.',
  'form.claimCheckFirst': 'Yours is the first bingo of the day.',
  'form.submit': 'Send',
  'form.sending': 'Sending',
  'form.freemail': 'That looks like a private address. Fine too.',
  'form.done': 'Confirmation email is on its way.',
  'form.certReady': 'Your certificate is ready.',
  'form.certShow': 'View certificate',

  'gm.title': 'Game master',
  'gm.search': 'Find a phrase',
  'gm.confirm': 'Confirm',
  'gm.veto': 'Reject',
  'gm.undo': 'Undo',
  'gm.undoWindow': '30 seconds',
  'gm.feed': 'Being marked now',
  'gm.queue': 'Review bingos',
  'gm.approve': 'Approve',
  'gm.reject': 'Decline',
  'gm.reason': 'Reason',
  'gm.start': 'Start',
  'gm.pause': 'Pause',
  'gm.end': 'End',
  'gm.announce': 'Announcement',
  'gm.nobody': 'Nothing marked yet.',
  'gm.players': '{n} marking',

  'board.rank': 'Rank',
  'board.points': 'Points',
  'board.quality': 'Sourcing',
  'board.you': 'You',
  'board.empty': 'No points yet.',
  'board.topToday': 'Most heard today',
  'board.lastBingos': 'Latest bingos',
  'board.joinNow': 'Play along',

  'create.title': 'Create a room',
  'create.occasion': 'Occasion',
  'create.visibility': 'Who gets in',
  'create.namePlaceholder': 'Tuesday vendor pitch',
  'create.private': 'Code only',
  'create.privateHint': 'The room is not listed. You pass the code on.',
  'create.public': 'Public',
  'create.publicHint': 'The room is listed on the start page. The code still works.',
  'create.occasion.vendor_pitch': 'Vendor pitch',
  'create.occasion.webinar': 'Webinar',
  'create.occasion.conference': 'Conference',
  'create.occasion.internal_meeting': 'Internal meeting',
  'create.set': 'Card set',
  'create.name': 'Title',
  'create.rules': 'Rules',
  'create.gmMode': 'Who confirms',
  'create.gmMode.crowd': 'The others in the room',
  'create.gmMode.hybrid': 'Room or game master',
  'create.gmMode.strict': 'Game master only',
  'create.minSources': 'A field counts from',
  'create.minSources.1': 'one source',
  'create.minSources.2': 'two sources',
  'create.submit': 'Create room',
  'create.done': 'Room is ready',
  'create.invite': 'Invite',
  'create.calendar': 'Add to calendar',
  'create.copy': 'Copy link',
  'create.copied': 'Copied',

  'admin.title': 'Administration',
  'admin.events': 'Events',
  'admin.newEvent': 'Create event',
  'admin.rooms': 'Public rooms',
  'admin.newRoom': 'Create room',
  'admin.roomTitle': 'Talk title',
  'admin.start': 'Start',
  'admin.pause': 'Pause',
  'admin.end': 'End',
  'admin.open': 'Open',
  'admin.leads': 'Leads',
  'admin.export': 'As CSV',
  'admin.standee': 'Standee',
  'admin.noAccess': 'This needs an account with admin rights.',
  'admin.live': 'This event is live',
  'admin.goLive': 'Go live',
  'admin.players': 'Players',
  'admin.marks': 'Marks',
  'account.title': 'Account',
  'account.email': 'Email',
  'account.send': 'Send link',
  'account.magicHow': 'Enter your address, open the link in the email, done. If there is no account yet, it is created on the way.',
  'account.noPassword': 'No password. The link is valid for 15 minutes and once.',
  'account.sent': 'Link is on its way. Valid for 15 minutes.',
  'account.name': 'Name on the leaderboard',
  'account.nameHint': 'This is all the others in the room see. Your account runs on the email address.',
  'account.signedInAs': 'Signed in as',
  'account.save': 'Save',
  'account.profile': 'Your profile',
  'account.profileHint': 'The more we know, the better the report and the conversation after. All optional.',
  'account.realName': 'Name',
  'account.company': 'Company',
  'account.role': 'Role',
  'account.sector': 'Sector',
  'account.country': 'Country',
  'account.petPeeve': 'Your favourite buzzword (the cringe one)',
  'account.petPeevePh': 'e.g. "AI-powered single pane of glass"',
  'account.newsletter': 'Keep me posted, bsbingo and CICS, if there is ever a newsletter. No spam, promise.',
  'account.saved': 'Saved',
  'account.nameTaken': 'That name did not pass. We set another one.',
  'account.history': 'History',
  'account.certificates': 'Certificates',
  'account.rooms': 'My rooms',
  'account.joinedRooms': 'Played in',
  'start.unknownCode': 'We do not know this code. Typo? Or the room is already closed.',
  'account.export': 'Export my data',
  'account.delete': 'Delete account',
  'account.deleteSure': 'Really delete? This cannot be undone.',

  'live.polling': 'Weak connection. Still running.',
  'live.offline': 'No network. Your marks will be sent later.',
  'live.queued': '{n} waiting for network',
  'live.synced': 'Sent.',

  'intro.title': 'How it works',
  'intro.step1': 'Tap what you just heard.',
  'intro.step2': 'If others heard it too, the field counts.',
  'intro.step3': 'Five in a row is a bingo.',
  'card.modeInfo': 'Show plain words',
  'card.modeMark': 'Back to marking',
  'card.markHint': 'Tap to mark. Press and hold for the plain words.',
  'card.tapHint': 'One tap marks and explains. Tap again to read it once more.',
  'card.infoHint': 'Tap for the plain words, our rating and the question to ask the vendor.',
  'why.title': 'Why does nothing count yet?',
  'why.needSource': 'A field counts once someone else in the room marks the same phrase. Your fields waiting for that: {n}.',
  'why.smallRoom': 'There are too few of you for the confirmation rule. Once more people join, a field needs a second source.',
  'intro.step4': 'Press and hold a field to see what the phrase actually means.',
  'intro.start': 'Go',
  'intro.skip': 'Skip',

  'err.offline': 'No connection.',
  'err.room_code_unknown': 'No open room for this code.',
  'err.not_running': 'The room is not running.',
  'err.card_locked': 'The card is locked while the room runs.',
  'err.reroll_used': 'One reshuffle, no more.',
  'err.banned': 'You were removed from this room.',
  'err.consent_missing': 'We need your consent.',
  'err.lead_exists': 'This address is already registered for this event.',
  'err.rate_limited': 'A little slower.',
  'err.generic': 'That did not work.',

  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.loading': 'One moment',
  'common.retry': 'Again',
  'common.language': 'Language',
  'common.theme': 'Appearance',
}

/** Die Rückfrage, in beiden Tonlagen (FR-CONF-01, FR-CONF-05). */
export const ASK_BODY: Record<Lang, Record<Tone, (term: string, others: number) => string>> = {
  de: {
    mundart: (term, others) =>
      `Nur du hesch „${term}“ ghört. Die andere ${others} im Ruum händ das nid markiert. ` +
      `Isch so viel Bullshit verzapft worde, oder hesch di verdrückt?`,
    hochdeutsch: (term, others) =>
      `Nur du hast „${term}“ gehört. Die anderen ${others} im Raum haben das nicht markiert. ` +
      `Wurde so viel Unsinn erzählt, oder hast du dich vertippt?`,
  },
  en: {
    mundart: (term, others) =>
      `Only you heard "${term}". The other ${others} in the room did not mark it. ` +
      `Was there really that much nonsense, or was it a mis-tap?`,
    hochdeutsch: (term, others) =>
      `Only you heard "${term}". The other ${others} in the room did not mark it. ` +
      `Was there really that much nonsense, or was it a mis-tap?`,
  },
}

const DICT: Record<Lang, Record<Key, string>> = { de, en }

export function detectLang(): Lang {
  const stored = (() => {
    try {
      return localStorage.getItem('bsb.lang')
    } catch {
      return null
    }
  })()
  if (stored === 'de' || stored === 'en') return stored
  return navigator.language.toLowerCase().startsWith('en') ? 'en' : 'de'
}

export function setLang(lang: Lang): void {
  try {
    localStorage.setItem('bsb.lang', lang)
  } catch {
    /* egal */
  }
}

export function translate(lang: Lang, key: Key, vars?: Record<string, string | number>): string {
  let out: string = DICT[lang][key] ?? DICT.de[key] ?? key
  if (vars) for (const [k, v] of Object.entries(vars)) out = out.replaceAll(`{${k}}`, String(v))
  return out
}

export function pick(text: { de?: string; en?: string } | undefined, lang: Lang): string {
  if (!text) return ''
  return text[lang] ?? text.de ?? text.en ?? ''
}

export type TranslateKey = Key
